<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Masters <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Branch Master <i
                    class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Edit Branch</h1>
            <div class="content-wrap">
                <form [formGroup]="editBranchForm">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="branchName" class="form-label">branch Name<span
                                        class="color-red">*</span></label>
                                <input type="text" placeholder="Enter the branch name" formControlName="branchName"
                                    [(ngModel)]="branchName" class="form-control form-input" id="branchName"
                                    [ngClass]="{'is-invalid': submitted && f.branchName.errors }" />
                                <div *ngIf="submitted && f.branchName.errors" class="invalid-feedback">
                                    <div *ngIf="f.branchName.errors.required">branch Name is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="stream" class="form-label">Stream<span class="color-red">*</span></label>
                                <select formControlName="streamId" class="form-control form-input"
                                    [(ngModel)]="streamId">
                                    <option selected disabled value="undefined">Select your stream</option>
                                    <option *ngFor="let stream of streamDropDown" [ngValue]="stream.id">
                                        {{stream.streamName}}</option>
                                </select>
                                <div class="invalid-feedback">
                                    <div>Stream is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="proceed-btn bg-theme" (click)="updateBranch()">Submit</button>
                    <button class="proceed-btn" (click)="goBack()">Cancel</button>
                </form>
            </div>
        </div>
    </div>
</div>
<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">{{strMessage}}</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>